import { ResendingStatus } from './VerifyEmail';

interface Props {
  readonly resendingStatus: ResendingStatus;
}

export function ResendStatus({ resendingStatus }: Props) {
  if (resendingStatus === ResendingStatus.Success) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-3 text-center">
        <p className="text-sm text-green-800 font-medium">Message sent successfully</p>
      </div>
    );
  } else if (resendingStatus == ResendingStatus.Error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-center">
        <p className="text-sm text-red-800 font-medium">
          Failed to resend verification email. Try again later!
        </p>
      </div>
    );
  }

  return null;
}
